import { useState,useEffect } from "react";

export default function useCam(){
    const [devices, setDevices] = useState([]);
    const [selectedDeviceId, setSelectedDeviceId] = useState("");
    const isPortrait = window.matchMedia("(orientation: portrait)").matches;
    
    // get Camera devices
    useEffect(() => {
        const getDevices = async () => {
            // Check if the page is secure
            const isSecure = window.location.protocol === 'https:' || window.location.hostname === 'localhost';
            if (!isSecure) {
                alert('Webcam access is not available on non-secure (HTTP) connections. Please visit this site over HTTPS.');
                return;
            }
            const devices = await navigator.mediaDevices.enumerateDevices();
            const videoDevices = devices.filter(
                (device) => device.kind === "videoinput"
            );
            setDevices(videoDevices);
            if (videoDevices.length > 0) {
                // alert(`Video devices: ${videoDevices.length}`);
                setSelectedDeviceId(videoDevices[videoDevices.length - 1].deviceId);
                // console.log("Video devices:", videoDevices);
            }
        };
        getDevices();
    }, []);

    return { devices, selectedDeviceId,setSelectedDeviceId, isPortrait };
}